import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import './SetupTracker.css';
import { ReactComponent as RightArrow } from '../../../assets/icons/arrow-right-icon.svg';
import { SetupTrackerContext } from '../../../objects/Context';

const SetupTracker = ({ closePage }) => {
    const navigate = useNavigate();
    const { setupSteps } = useContext(SetupTrackerContext);
    
    // Calculate progress percentage locally
    const completedSteps = setupSteps?.filter(step => step.completed).length;
    const progressPercentage = (completedSteps / setupSteps?.length) * 100;

    const handleStepClick = (step) => {
        if (step.path) {
            // Pass state when navigating to different pages to open relevant modals
            if (step.path === '/data-sources') {
                navigate(step.path, { state: { addDataSourceOpen: true } });
            } else if (step.path.startsWith('/forecast')) {
                // Allow query params like /forecast?mode=dashboard
                const [pathname, search] = step.path.split('?');
                navigate({ pathname, search: search ? `?${search}` : '' });
            } else if (step.path === '/reports') {
                navigate(step.path, { state: { showNewReportDropdown: true } });
            } else if (step.path === '/settings') {
                navigate(step.path, { state: { selectedMenuItem: 'members' } });
            } else {
                navigate(step.path);
            }
        }
        if (closePage) {
            closePage();
        }
    };

    const handleClose = () => {
        if (closePage) {
            closePage();
        }
    };

    return (
        <div className="setup-tracker">
            <button className="close-button" onClick={handleClose}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path 
                        d="M12 4L4 12M4 4L12 12" 
                        stroke="currentColor" 
                        strokeWidth="2" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                    />
                </svg>
            </button>
            
            <h1 className="setup-title">Finish Setup</h1>
            
            <div className="progress-container">
                <div className="progress-bar">
                    <div 
                        className="progress-fill" 
                        style={{ width: `${progressPercentage}%` }}
                    ></div>
                </div>
            </div>

            <div className="steps-list">
                {setupSteps?.map((step) => (
                    <div 
                        key={step.id} 
                        className={`step-item`}
                        onClick={() => handleStepClick(step)}
                    >
                        <div className={`step-icon ${step.completed ? 'completed' : 'pending'}`}>
                            {step.completed && (
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                    <path 
                                        d="M2 6L5 9L10 3" 
                                        stroke="white" 
                                        strokeWidth="2" 
                                        strokeLinecap="round" 
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            )}
                        </div>
                        <span className="step-title">{step.title}</span>
                        <RightArrow className="step-arrow" />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SetupTracker;
